import type { ReminderResponse } from "../../shared/api/client";

/**
 * What the owner can do with a reminder. Owners never mark reminders done:
 * a sent one-off closes itself, one the bot failed to send stays active and
 * overdue, and a completed repeat can only mean the owner stopped it.
 */
type ReminderStatus = "active" | "missed" | "stopped" | "sent";

export function reminderStatus(item: ReminderResponse): ReminderStatus {
  if (item.state === "active") return item.missed ? "missed" : "active";
  if (item.state === "completed" && item.recurrence !== "once")
    return "stopped";
  return "sent";
}
